// Import contract ABIs
import ERC20_ABI from "../abis/ERC20.json";
import FACTORY_ABI from "../abis/Factory.json";
import ROUTER_ABI from "../abis/Router.json";
import POKEMON_TOKEN_ABI from "../abis/PokemonToken.json";
import NFT_ABI from "../abis/Nft.json";
import MARKETPLACE_ABI from "../abis/Marketplace.json";
import PACKS_ABI from "../abis/Packs.json";
import REFERRAL_ABI from "../abis/Referrals.json";
import XTOKEN_ABI from "../abis/Xtoken.json";
import GACHA_ABI from "../abis/Gacha.json";

let CONTRACT_ADDRESSES;
// Checking the staging or live
if (process.env.REACT_APP_ENV === "staging") {
    // Contract addresses for BSC Mainnet
    CONTRACT_ADDRESSES = {
        FACTORY: "0xA8DeF7E230A63fE5dd2a6d7b18c9785f8885Df8A",
        ROUTER: "0x11b5DA417D5a0312861f8325D73F0DA9998C4e89",
        USDT: "0xfa689719189fA0c8E1571AeCf4527960B8f62f32",
        NFT: "0x6F337b61B9A0f6e3823ec597007C7cA313Aa7CD9",
        MARKETPLACE: "0x5447665f04598d49aAeE0030118589274bf30D42",
        PACKS: "0xa8DA24099C3861d8A98189E3d93333281B473A33",
        REFERRALS: "0xfd705bCEF5647f76321f1C87f3980Da48B423c48",
        XTOKEN: "0xfa689719189fA0c8E1571AeCf4527960B8f62f32",
        AVAULT: "0x8BfA05986Ad07B5C7B1E68AdF896a246c0Ba5062",
        GACHA: "0x9d887267F86C294a0f02859a3ED29DBf4A99E425",
    };
} else {
    // Contract addresses for BSC Mainnet
    CONTRACT_ADDRESSES = {
        FACTORY: "0xcA143Ce32Fe78f1f7019d7d551a6402fC5350c73",
        ROUTER: "0x10ED43C718714eb63d5aA57B78B54704E256024E",
        // Deployed contracts
        NFT: "0x97f1299b61C1d0aD20f7d6287003a471ad411B5f",
        USDT: "0x55d398326f99059fF775485246999027B3197955",
        PACKS: "0x498D3E29e3DF158f541d9EaA0dc01d182380ff59",
        REFERRALS: "0xae811338E6B4993c95B0ac43431339428f185Aa4",
        XTOKEN: "0x53Adec8A46231e8FF4a52428076e26AD2c445Df5",
        AVAULT: "0x822d5c03CFb5D10dC15C0B18fe6Ad2cC9283bD91",
        GACHA: "0x9d887267F86C294a0f02859a3ED29DBf4A99E425",
    };
}

export { CONTRACT_ADDRESSES };

let API_URL;

if (process.env.REACT_APP_ENV === "staging") {
    API_URL = 'https://public-buynode-pokemon.madxapp.com';
} else {
    API_URL = 'https://public-buynode-pokemon.tcg.zone';
}

export { API_URL };

// Multiple RPC URLs for better reliability
export const RPC_URLS = {
    BSC_MAINNET: [
        // "https://sparkling-rough-snow.bsc.quiknode.pro/cce24e8869f9997e4fd1e55c011a6363f0551098",
        "https://bsc-dataseed1.binance.org/", // Binance official
        "https://bsc-dataseed2.binance.org/", // Binance official backup
        "https://bsc-dataseed3.binance.org/", // Binance official backup
        "https://bsc-dataseed4.binance.org/", // Binance official backup
        "https://bsc-dataseed1.defibit.io/", // Defibit
        "https://bsc-dataseed1.ninicoin.io/", // Ninicoin
    ],
    BSC_TESTNET: "https://data-seed-prebsc-1-s1.binance.org:8545/",
};

// Default slippage settings
export const DEFAULT_SLIPPAGE = 0.5;

// Transaction deadline (20 minutes)
export const TRANSACTION_DEADLINE = 60 * 20;

// Toast positions
export const TOAST_POSITION = "top-right";

export const BSC_CHAIN_ID = 56;

export const NETWORK_CONFIG = {
    BSC_MAINNET: {
        chainId: "0x38", // 56 in decimal
        chainName: "Binance Smart Chain",
        nativeCurrency: {
            name: "BNB",
            symbol: "BNB",
            decimals: 18,
        },
        rpcUrls: RPC_URLS.BSC_MAINNET,
        blockExplorerUrls: ["https://bscscan.com/"],
    },
};

// Contract ABIs
export const CONTRACT_ABIS = {
    ERC20: ERC20_ABI,
    FACTORY: FACTORY_ABI,
    ROUTER: ROUTER_ABI,
    POKEMON_TOKEN: POKEMON_TOKEN_ABI,
    NFT: NFT_ABI,
    MARKETPLACE: MARKETPLACE_ABI,
    PACKS: PACKS_ABI,
    REFERRALS: REFERRAL_ABI,
    XTOKEN: XTOKEN_ABI,
    GACHA: GACHA_ABI
};

// Token information
// export const TOKEN_INFO = {
//     NEXT: {
//         address: CONTRACT_ADDRESSES.NEXT_TOKEN,
//         symbol: "NEXT",
//         name: "NextFi Token",
//         decimals: 18,
//         logo: "/images/tokens/next.png",
//     },
//     USDT: {
//         address: CONTRACT_ADDRESSES.USDT,
//         symbol: "USDT",
//         name: "Tether USD",
//         decimals: 18,
//         logo: "/images/tokens/usdt.png",
//     },
//     WBNB: {
//         address: CONTRACT_ADDRESSES.WBNB,
//         symbol: "WBNB",
//         name: "Wrapped BNB",
//         decimals: 18,
//         logo: "/images/tokens/wbnb.png",
//     },
// };

// Contract interaction helpers
export const CONTRACT_HELPERS = {
    // Format token amount for display
    formatTokenAmount: (amount, decimals = 18) => {
        return (parseFloat(amount) / Math.pow(10, decimals)).toFixed(2);
    },

    // Convert display amount to wei
    parseTokenAmount: (amount, decimals = 18) => {
        return (parseFloat(amount) * Math.pow(10, decimals)).toString();
    },

    // Get contract instance
    getContract: (address, abi, provider) => {
        return { address, abi, provider };
    },
};

// Gas settings
export const GAS_SETTINGS = {
    DEFAULT_GAS_LIMIT: 300000,
    BUY_NODE_GAS_LIMIT: 500000,
    APPROVE_GAS_LIMIT: 100000,
};
